import Tooltip from "@mui/material/Tooltip";
import styles from "./styles/Styles.module.css";

const BasicTooltip = (props) => (
  <Tooltip
    {...props}
    title={
      props.title ? (
        <div className={styles.basicTooltipContent}>{props.title}</div>
      ) : (
        props.title
      )
    }
    classes={{
      tooltip: styles.basicTooltip,
      popper: styles.tooltipPopper,
      arrow: styles.basicTooltipArrow,
      ...props.classes,
    }}
  />
);

export default BasicTooltip;
